<template>
    <div class="Outer-frame">
          <el-container style="min-width:1280px;">
                <el-main>
                    <div class="main">
                        <div class="main-header">
                            <div class="main-headerleft">
                                <img src="../assets/images/mobiigw/mobii.png" alt="">
                            </div>
                            <div class="main-headerright">
                                <div class="headerrightpa">
                                    Mobii!
                                </div>
                                <div class="headerrightpb">
                                    每次乘车，总是惊喜！
                                </div>
                                <span class="headerrightsp">
                                    5G出行新时代
                                </span>
                                <div class="btn">
                                    <div class="btn-ios">
                                        <img src="../assets/images/mobiigw/ios.png" alt="">
                                        <span>
                                            iOS版
                                        </span>
                                    </div>
                                    <div class="btn-android">
                                        <img src="../assets/images/mobiigw/android.png" alt="">
                                        <span>
                                            Android版
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="main-middle">

                            <div class="main-middleone">
                                <div class="middleonepa">
                                   Mobii!
                                </div>
                                <div class="middleonepb">
                                    乘车码坐车抽好礼
                                </div>
                                <div class="middleonespana">
                                    上车一秒感应
                                </div>
                                <div class="middleonespanb">
                                    下车领取彩蛋！
                                </div>
                            </div>
                            <div class="main-middletwo">
                                <div class="middletwopa">
                                    Mobii! 莫粉募集中
                                </div>
                                <div class="middletwopb">
                                    五大功能抢先体验
                                </div>
                                <div class="middletwoul">
                                    <div class="middletwoulheader">
                                        <div>
                                            <img src="../assets/images/mobiigw/good gift.png" alt="">
                                            <P>限时交通联名卡</P>
                                            <P>送超值好礼</P>
                                        </div>
                                        <div>
                                            <img src="../assets/images/mobiigw/mbii.png" alt="">
                                            <P>每日赚M币</P>
                                            <p>周周抽好礼</p>
                                        </div>
                                        <div>
                                            <img src="../assets/images/mobiigw/seconds.png" alt="">
                                            <p>Mobii!商城</p>
                                            <p>爆款1元秒杀</p>
                                        </div>
                                    </div>
                                    <div class="middletwoulbottom">
                                        <div>
                                            <img src="../assets/images/mobiigw/location.png" alt="">
                                            <P>智能优惠推荐</P>
                                            <P>走到哪省到哪</P>
                                        </div>
                                        <div>
                                            <img src="../assets/images/mobiigw/game.png" alt="">
                                            <P>游戏测你好手气</P>
                                            <p>免费大奖等你拿</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="main-middlethree">
                                <div class="main-listcontentsleft">
                                    <ul>
                                        <li>
                                            <p class="maintitle">Mobii！联名乘车卡限时领</p>
                                        </li>
                                        <li>
                                            <p class="middle-li">一卡在手 全国通行</p>
                                        </li>
                                        <li>
                                            <p class="middle-li">优惠福利多到爆 消费积分能抵现</p>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div class="main-middlefour">
                                <div class="main-listcontentsright">
                                    <ul>
                                        <li>
                                            <p class="maintitle">做任务赚M币</p>
                                        </li>
                                        <li>
                                            <p class="middle-li">每日任务赚M币</p>
                                        </li>
                                        <li>
                                            <p class="middle-li">换豪礼，兑现金</p>
                                        </li>
                                        <li>
                                            <p class="middle-li">周周再抽限量商品</p>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div class="main-middlefive">
                                 <div class="main-listcontentsleft">
                                    <ul>
                                        <li>
                                            <p class="maintitle">莫比！商城狂欢季</p>
                                        </li>
                                        <li>
                                            <p class="middle-li">每周一荐爆款最低价</p>
                                        </li>
                                        <li>
                                            <p class="middle-li">1元商店等你来挖宝</p>
                                        </li>
                                        <li>
                                            <p class="middle-li">商品琳琅满目件件优惠</p>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div class="main-middlesix">
                                <div class="main-Ylistcontentsright">
                                    <ul>
                                        <li>
                                            <p class="Ymaintitle">优惠如影随形</p>
                                        </li>
                                        <li>
                                            <p class="Ymiddle-li">乘车出<span class="Yspan">行0</span>元起</p>
                                        </li>
                                        <li>
                                            <p class="Ymiddle-li">精选好<span class="Yspan">物1</span>元购</p>
                                        </li>
                                        <li>
                                            <p class="Ymiddle-li">美食玩<span class="Yspan">乐1</span>折抢</p>
                                        </li>
                                        <li>
                                            <p class="Ymiddle-li">周边景点折上折</p>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div class="main-middleserven">
                                <div class="main-listcontentsleft">
                                    <ul>
                                        <li>
                                            <p class="maintitle">游戏赢彩蛋</p>
                                        </li>
                                        <li>
                                            <p class="middle-li">刮刮乐，大转盘...</p>
                                        </li>
                                        <li>
                                            <p class="middle-li">0元乘车，免费搭乘</p>
                                        </li>
                                        <li>
                                            <p class="middle-li">幸运儿就是你！</p>
                                        </li>
                                    </ul>
                                </div>
                            </div>

                        </div>

                    </div>
                </el-main>

                <el-footer>
                    <div class="bottom">
                        <img src="../assets/images/mobiigw/slogin.png" alt="">
                    </div>
                    <div class="footer">
                        <div class="footer-main">
                            <div class="footer-header">
                                <div class="footer-left">
                                    <div class="footer-left-title">
                                        联系我们
                                    </div>
                                    <div class="footer-left-content">
                                        联系电话：025-83728416
                                    </div>
                                    <div class="footer-left-content">
                                        官方微信：njmobii01
                                    </div>
                                    <div class="footer-left-content">
                                        官方邮箱：Mobii@justgoai.com
                                    </div>
                                </div>
                                <div class="footer-right">
                                    <div class="footer-right-title">
                                        关注我们
                                    </div>
                                    <div class="footer-right-content">
                                        <div class="footer-right-content-left">
                                            <img src="../assets/images/mobiigw/wechat.png" alt="">
                                            <p>APP下载</p>
                                        </div>
                                        <div class="footer-right-content-middle">
                                            <img src="../assets/images/mobiigw/gongzhonghao.png" alt="">
                                            <p>官方微信公众号</p>
                                        </div>
                                        <div class="footer-right-content-right">
                                            <img src="../assets/images/mobiigw/weibo.png" alt="">
                                            <p>官方微博</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="footer-middle">

                            </div>
                            <div class="footer-bottom" >
                              <div style="float:left;padding-top: 5px;">
                                  <a href="https://xyt.xcc.cn/getpcInfo?sn=1610602639735627776&language=CN&certType=8&url=*.justgoai.com" target="_blank"
                                    style="position: relative;display: inline-block;height: 38px;">
                                    <div style="width:100%;height:100%;position: absolute;top: 0;left: 0;"></div>
                                    <embed src="https://program.xinchacha.com/web/1610602639735627776=*.justgoai.com.svg" width="103" height="38" type="image/svg+xml" pluginspage="//www.adobe.com/svg/viewer/install/"/>
                                  </a>
                               </div>


                                <div style="float:right;">
                                  <a href="http://beian.miit.gov.cn/" target="_blank">
                                      <p>&nbsp; &nbsp; &nbsp; 版权所有 © 广东莫比科技有限公司 粤ICP备18159870号</p>
                                  </a>
                                </div>
                            </div>

                        </div>
                    </div>
                </el-footer>
            </el-container>
    </div>
</template>
<script>
export default {
    data(){
        return{
            // activeIndex:'aboutus'
        }
    }
    // methods:{
    //     handleSelect(){

    //     },
    //     aboutus(){
    //         //window.sessionStorage.clear();
    //         // this.$router.push('/aboutus');
    //         // this.$router.push({path:'/aboutus'});
    //         this.$router.replace({  //核心语句
    //         path:'/aboutus' ,  //跳转的路径
    //     })
    //     },
    // }
}
</script>
<style scoped>
    .Outer-frame{
        min-width: 1280px;
        margin: 0px;
        padding: 0px;
        flex-direction: column;
    }

    .logo{
        margin-left: 13%;
        margin-top: 20px;
    }

    .el-menu-demo{
        float: right;
    }

    .el-main{
        padding: 20px 0;
    }

    .el-footer{
        padding: 0 0;
    }

    .main{
        width: 100%;
    }

    .main-header{
        height: 12.2%;
        width: 100%;
        display: flex;
        flex-direction: row;
        background:rgba(255,228,2,1);
    }

    .main-headerleft{
        width: 50%;
        height: 100%;
    }

    .main-headerleft img{
        height: 80%;
        margin-top: 14.45%;
        margin-bottom: 14.45%;
        float: right;
    }

    .main-headerright{
        width: 30%;
        margin-top: 6%;
        text-align: center;
        display: flex;
        flex-direction: column;
    }

    .headerrightpa{
        height: 70px;
        margin-top: 30.84%;
        font-size:36px;
        font-family:PingFangSC-Medium,PingFang SC;
        font-weight:500;
        color:rgba(19,51,76,1);
    }

    .headerrightpb{
        height: 70px;
        font-size:36px;
        font-family:PingFangSC-Medium,PingFang SC;
        font-weight:500;
        color:rgba(19,51,76,1);
    }

    .headerrightsp{
        height:28px;
        font-size:20px;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
        color:rgba(51,51,51,1);
        line-height:28px;
        letter-spacing:1px;
    }

    .btn{
        width: 100%;
        margin-top: 15%;
        display: flex;
        flex-direction: row;
    }

    .btn span{
        margin-left: 5%;
    }

    .btn-ios{
        display: flex;
        flex-direction: row;
        margin-left: 11%;
        width: 150px;
        height: 40px;
        align-items: center;
        background:rgba(255,255,255,1);
        border-radius:21px;
    }

    .btn-ios img{
        margin-left: 26%;
    }

    .btn-android{
        display: flex;
        flex-direction: row;
        width: 150px;
        height: 40px;
        align-items: center;
        background:rgba(255,255,255,1);
        border-radius:21px;
        margin-left: 1.04%;
    }

    .btn-android img{
        margin-left: 16%;
    }

    .main-middle{
        margin-top: 1.42%;
        display: flex;
        flex-direction: column;
        margin: 0 auto;
        width: 71.11%;
    }

    .main-middle ul li{
        list-style: none;
    }

    .main-middleone{
        width: 100%;
        height: 561px;
        text-align: center;
        margin-top: 90px;
        background-size: 100% 100%;
        background-image: url('../assets/images/mobiigw/scan.png');
    }

    .main-middleone img{
        width: 100%;
        height: 100%;
    }

    .middleonepa{
        margin-top: 50px;
        font-size:28px;
        font-family:PingFangSC-Medium,PingFang SC;
        font-weight:500;
        color:rgba(255,255,255,1);
        line-height:40px;
    }

    .middleonepb{
        font-size:28px;
        font-family:PingFangSC-Medium,PingFang SC;
        font-weight:500;
        color:rgba(255,255,255,1);
        line-height:40px;
    }

    .main-middletwo{
        display: flex;
        flex-direction: column;
        text-align: center;
        margin-top: 90px;
        width: 100%;
        height: 536px;
        background:rgba(244,246,242,1);
    }

    .middletwopa{
        margin-top: 52px;
        height: 7.46%;
        font-size: 28px;
        font-family: PingFangSC-Medium,PingFang SC;
        font-weight: 500;
        color: rgba(0,0,0,1);
        line-height: 40px;
    }

    .middletwopb{
        margin-top: 12px;
        height: 7.46%;
        font-size: 20px;
        font-family: PingFangSC-Medium,PingFang SC;
        font-weight: 500;
        color: rgba(0,0,0,1);
        line-height: 40px;
    }

    .middletwoul{
        margin: 0;
        padding: 0;
        width: 80%;
        margin: 0 auto;
        display: flex;
        flex-direction: column;
        justify-content: center;
    }

    .middletwoul img{
        margin-bottom: 13px;
    }

    .middletwoul p{
        margin: 0;
        padding: 0;
        line-height: 26px;
    }

    .middletwoulheader{
        width: 100%;
        margin-top: 50px;
        margin-bottom: 50px;
        display: flex;
        flex-direction: row;
        justify-content: space-around;

    }

    .middletwoulbottom{
        width: 65%;
        margin: 0 auto;
        display: flex;
        justify-content: space-around;
    }

    ul{
        padding-inline-start: 0;
    }

    .main-middlethree{
        width: 100%;
        height: 673px;
        background-size: 100% 100%;
        background-image: url('../assets/images/mobiigw/homepage.png');
    }

    .main-middlefour{
        width: 100%;
        height: 713px;
        margin-top: -40px;
        background-size: 100% 100%;
        background-image: url('../assets/images/mobiigw/taskpage.png');
    }

    .main-middlefive{
        width: 100%;
        height: 713px;
        margin-top: -40px;
        background-size: 100% 100%;
        background-image: url('../assets/images/mobiigw/shangcheng.png');
    }

    .main-middlesix{
        width: 100%;
        height: 713px;
        margin-top: -40px;
        background-size: 100% 100%;
        background-image: url('../assets/images/mobiigw/surroundpage.png');
    }

    .main-middleserven{
        width: 100%;
        height: 673px;
        margin-top: -40px;
        background-size: 100% 100%;
        background-image: url('../assets/images/mobiigw/gamepage.png');
    }

    .bottom{
        width: 100%;
        height: 311px;
        text-align: center;
        line-height: 400px;
        background:rgba(248,248,248,1);
        margin-top: 164px;
    }

    .maintitle{
        font-size:28px;
        font-family:PingFangSC-Medium,PingFang SC;
        font-weight:500;
        color:rgba(255,255,255,1);
    }

    .middle-li{
        margin: 0;
        padding: 0;
        font-size:20px;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
        line-height: 28px;
        color:rgba(255,255,255,1);
    }

    .Ymaintitle{
        font-size:28px;
        font-family:PingFangSC-Medium,PingFang SC;
        font-weight:500;
        color:rgba(19,51,76,1);
    }

    .Ymiddle-li{
        font-size:20px;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
        color:rgba(19,51,76,1);
        margin: 0;
        margin-bottom: 6px;
        padding: 0;
    }

    .Yspan{
        letter-spacing: 5px;
    }

    .hr{
        width: 71.11%;
        height: 1px;
        background-color: white;
        margin:0 auto;
    }

    .signature{
        width: 100%;
        height:84px;
        font-size:14px;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
        color:rgba(221,221,221,1);
        line-height:21px;
        text-align: center;
        margin-bottom: 20px;
    }

    .signature ul li{
        list-style: none;
    }

    .main-listcontentsleft{
        text-align: center;
        width: 50%;
        margin-top: 28%;
        margin-left: 8%;
    }

    .main-listcontentsright{
        float: right;
        text-align: center;
        width: 50%;
        margin-top: 28%;
        margin-right: 8%;
    }

    .main-Ylistcontentsright{
        float: right;
        text-align: center;
        width: 50%;
        margin-top: 266px;
        margin-right: 8%;
    }

    .el-menu{
        border-bottom: none;
    }

    a{
        text-decoration: none;
    }

    .middleonespana {
        height:28px;
        font-size:20px;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
        color:rgba(255,255,255,1);
        line-height:28px;
        text-align: left;
        margin-top: 85px;
        margin-left: 320px;
    }
    .middleonespanb {
        height:28px;
        font-size:20px;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
        color:rgba(255,255,255,1);
        line-height:28px;
        float: left;
        margin-top: 193px;
        margin-left: 500px;
    }

    .footer{
        width: 100%;
        height: 343px;
        background:rgba(129,129,129,1);
        padding: 0;
    }

    .footer-main{
        width: 71.11%;
        display: flex;
        flex-direction: column;
        margin: 0 auto;
    }

    .footer-header{
        width: 100%;
        display: flex;
        flex-direction: row;
        margin: 0 auto;
    }

    .footer-left{
        width: 30%;
    }

    .footer-right{
        width: 70%;
    }

    .footer-left-title,.footer-right-title{
        height:30px;
        font-size:22px;
        font-family:PingFangSC-Medium,PingFang SC;
        font-weight:500;
        color:rgba(255,255,255,1);
        line-height:30px;
        margin-top: 44px;
    }

    .footer-left-content{
        height:20px;
        font-size:14px;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
        color:rgba(221,221,221,1);
        line-height:20px;
        margin-top: 26px;
    }

    .footer-right-content{
        width: 70%;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        margin: 26px 0 0 -26px;
    }

    .footer-right-content img{
        width: 94px;
        height: 94px;
    }

    .footer-right-content-left,.footer-right-content-middle,.footer-right-content-right{
        margin: 0 auto;
        text-align: center;
    }

    .footer-right-content-left,.footer-right-content-middle,.footer-right-content-right p{
        height:20px;
        font-size:14px;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
        color:rgba(255,255,255,1);
        line-height:20px;
    }

    .footer-middle{
        width: 100%;
        height: 1px;
        background-color: #aaaaaa;
        margin-top: 1%;
        margin-bottom: 1%;
    }

    .footer-bottom{
        margin: 0 auto;
    }

    .footer-bottom p{
        text-align: center;
        height: 21px;
        font-size:14px;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
        color:rgba(221,221,221,1);
        line-height: 21px;
    }

</style>



// WEBPACK FOOTER //
// src/modules/home.vue